import { Fragment } from 'react';
import { useTheme, useUniqueId, ChartState } from '@shopify/polaris-viz-core';
import styles from './SimpleNormalizedSkeleton.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorText } from '../ErrorText/ErrorText.js';

const SIZE_TO_PX = {
  small: 16,
  medium: 36,
  large: 56
};
function SimpleNormalizedSkeleton({
  dimensions,
  errorText,
  showLegend,
  size,
  state
}) {
  const {
    width,
    height
  } = dimensions;
  const {
    grid: {
      color: gridColor
    },
    bar: {
      borderRadius
    },
    chartContainer: {
      padding
    }
  } = useTheme();
  const id = useUniqueId('simple-bar-skeleton');
  return /*#__PURE__*/jsxs("div", {
    style: {
      padding
    },
    children: [state === ChartState.Loading && /*#__PURE__*/jsxs(Fragment, {
      children: [showLegend && /*#__PURE__*/jsx("div", {
        className: styles.Legend,
        children: new Array(3).fill(0).map((_, index) => /*#__PURE__*/jsx("div", {
          className: styles.LegendItem,
          children: new Array(3).fill(0).map((_, innerIndex) => /*#__PURE__*/jsx("div", {
            className: styles.LegendItemComponent,
            style: {
              background: gridColor
            }
          }, `${id}${index}${innerIndex}`))
        }, `${id}${index}`))
      }), /*#__PURE__*/jsx("div", {
        style: {
          background: gridColor,
          borderRadius,
          height: SIZE_TO_PX[size]
        }
      })]
    }), state === ChartState.Error && /*#__PURE__*/jsx("svg", {
      viewBox: `0 0 ${width} ${height}`,
      children: /*#__PURE__*/jsx(ErrorText, {
        errorText: errorText,
        width: width,
        height: height
      })
    })]
  });
}

export { SimpleNormalizedSkeleton };
